import { cardRef, defineGameCard, onDeath } from '../authoring/index.js';
import { createFragmentInLocation, fragmentLocationsByPriority } from './helpers.js';
export const AssemblyRobotCard = defineGameCard({
    id: 'assembly_robot',
    gameplay: {
        type: 'UNIT', cost: 3,
        baseStats: { attack: 3, health: 3 },
    },
    presentation: {
        name: 'Сборочный робот',
        description: 'Распад 2: создаёт до 2 Фрагментов в разных локациях. Сначала создаёт их там, где уже есть ваш Фрагмент.',
        glyph: {
            colors: ['#10213A', '#D2CABA', '#CD6533', '#628485', '#A89991'],
            rows: [
                '....................',
                '.......111111.......',
                '.......122221.......',
                '.......123421.......',
                '......1122221..1..1.',
                '.....133332221151121',
                '.....133332222152221',
                '....1333332222115221',
                '..111333444422211521',
                '.152333344442222221.',
                '.15213334444522121..',
                '152213354444551.1...',
                '152211555555551.....',
                '12121155555551......',
                '.1.1..15555551......',
                '.....111111111......',
                '....12221..1221.....',
                '....15551..15551....',
                '.....111....111.....',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('fragment'), cardRef('reconstructed_robot')],
    abilities: [
        onDeath((ctx) => {
            const self = ctx.self;
            let created = 0;
            for (const tableId of fragmentLocationsByPriority(ctx, self.controllerId)) {
                if (createFragmentInLocation(ctx, self.controllerId, tableId).created !== null)
                    created += 1;
                if (created === 2)
                    break;
            }
        }),
    ],
    ui: { mechanics: ['decay', 'fragment'] },
});
//# sourceMappingURL=assembly-robot.js.map